import _ from 'lodash'
import {createProjectModel} from 'crm/utils/project-model'
import {formatTableParams} from 'utils/index'
import {getStaffTaskStatList, exportData} from './service'

function reformatParams(params) {
    const newParams = {...params}
    if (params?.start_time) {
        newParams.expire_time_begin = newParams.start_time
        newParams.expire_time_end = newParams.end_time
        delete newParams.start_time
        delete newParams.end_time
    }
    return newParams
}

const model = createProjectModel({
    projectNamespace: 'staffStat',
    state: {
        tableData: {},
        exportParams: {}, // 导出参数
        detailTable: {},
    },

    effects: {
        *getTableList(x, {select, put, call}) {
            const {tableData} = yield select((allState) => allState[model.namespace])
            const params = formatTableParams(tableData)
            const newParams = reformatParams(params)
            if (tableData.sorter?.columnKey) {
                newParams.order_by = tableData.sorter?.columnKey
            }

            if (tableData.sorter?.order) {
                newParams.asc = tableData.sorter?.order === 'descend' ? 0 : 1
            }
            const res = yield call(getStaffTaskStatList, newParams)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = _.get(res, 'pagination.rows_found', 0)
                    draft.exportParams = {...params}
                },
            })
        },

        *exportData(x, {call, select}) {
            const {tableData} = yield select((allState) => allState[model.namespace])
            const params = formatTableParams(tableData)
            const newParams = reformatParams(params)
            return yield call(exportData, newParams)
        },
    },
})

export default model
